import memoize from 'memoizee';
import parameters from '../../parameters';

const run = (...args: Parameters<typeof fetch>) => globalThis.fetch(...args);

const memoizedRun = memoize(
	async (...args: Parameters<typeof run>) => {
		return run(...args).then((response) => {
			memoizedRun.delete(...args);
			return response;
		});
	},
	{ promise: true, normalizer: JSON.stringify },
);

const concurrencyRun = (...args: Parameters<typeof memoizedRun>) =>
	memoizedRun(...args).then((response) => response.clone());

const memoizedRefreshToken = memoize(
	async (): Promise<void> => {
		try {
			await fetch(`${parameters.api.host}/api/token/refresh`, {
				method: 'POST',
				credentials: 'include',
				headers: {
					'Accept-Language': 'fr',
					accept: 'application/json',
				},
			});
		} finally {
			memoizedRefreshToken.delete();
		}
	},
	{ promise: true },
);

export { concurrencyRun as concurrencyFetch, memoizedRefreshToken as refreshToken };
